export default {
	"信用分": "Cote de crédit",
	"银行卡信息":"Carte bancaire",
	"语言":"langue",
	"首页":"Home",
	"电影":"Film",
	"我的": "le mien",
	"请求失败":"La demande a échoué",
	"选妃":"TemuCinta",
	"高端": "haut de gamme",
	"认证":"Attestation",
	"视频认证":"Authentification vidéo",
	"收费区间":"Plage de charge",
	"身高":"hauteur",
	"胸围": "tour de poitrine",
	"服务城市：全国各地 航空运输：是":"Villes desservies : Dans tout le pays Transport aérien : Oui",
	"我要约她":"Je veux sortir avec elle",
	"住所":"résidence",
	"个人简介":"Profil",
	"请联系顾问或接待员":"Veuillez contacter un conseiller ou un réceptionniste",
	"投票":"voter",
	"全部":"tous",
	"刷新成功": "Actualisation réussie",
	"尽享高端区":"Profitez du quartier haut de gamme",
	"享受极致奢华体验":"Profitez de l'expérience de luxe ultime",
	"空降":"aéroporté",
	"查看更多":"Voir plus",
	"热门推荐":"Recommandations populaires",
	"获取中":"Obtenir",
	"登录": "Se connecter",
	"忘记密码":"oublier le mot de passe",
	"没有账户？马上注册":"Vous n'avez pas de compte ? Inscrivez-vous maintenant",
	"请输入用户名":"Veuillez saisir votre nom d'utilisateur",
	"请输入密码":"Veuillez entrer le mot de passe",
	"注册":"registre",
	"请输入用户名(6-12个英文字母或数字)":"Veuillez entrer votre nom d'utilisateur (6 à 12 lettres ou chiffres anglais)",
	"请输入登录密码(6-12个英文字母或数字)":"Veuillez saisir votre mot de passe de connexion (6 à 12 lettres ou chiffres anglais)",
	"我已经知晓并同意开户协议各项条约":"J'ai compris et accepté les termes de la convention d'ouverture de compte",
	"请输入邀请码":"Veuillez entrer le code d'invitation",
	"请勾选下方开户协议":"Veuillez consulter la convention d'ouverture de compte ci-dessous",
	"投票结果":"Résultats du vote",
	"提交":"soumettre",
	"当前选号": "Sélection actuelle",
	"每注金额":"Montant par pari",
	"请输入金额": "Veuillez saisir le montant",
	"元":"€",
	"总共":"Total",
	"注":"Note",
	"合计":"Total",
	"任务单": "ordre des tâches",
	"清空订单":"Effacer la commande",
	"确认提交":"Confirmer la soumission",
	"期号":"Numéro de série",
	"中奖号码":"Numéros gagnants",
	"鲜花":"fleurs",
	"气球":"ballon",
	"棒棒糖":"Sucette",
	"烟花": "feux d'artifice",
	"未选择":"Non sélectionné",
	"金额错误":"Mauvais montant",
	"请选号":"Veuillez sélectionner un numéro",
	"请填写金额":"Merci de renseigner le montant",
	"余额不足，请联系客服充值":"Si le solde est insuffisant, veuillez contacter le service client pour recharger.",
	"未选中":"Non sélectionné",
	"请联系管理员领取该任务": "Veuillez contacter l'administrateur pour recevoir cette tâche",
	"开奖成功，期号：":"Le tirage au sort a été réussi, numéro d'émission:",
	"请输入您的收款卡信息":"Veuillez saisir les informations de votre carte de paiement",
	"银行卡号": "numéro de carte",
	"请输入真实银行卡号": "Veuillez saisir votre vrai numéro de carte bancaire",
	"银行名称":"Nom de la banque",
	"尊敬的用户,为了保障您的资金安全,请您绑定您的真实姓名和设置取款密码,如果姓名与开户名不一致,将无法取款":"Cher utilisateur, afin d'assurer la sécurité de vos fonds, veuillez lier votre vrai nom et définir un mot de passe de retrait. Si votre nom ne correspond pas au nom d’ouverture du compte, vous ne pourrez pas retirer d’argent.",
	"确认绑卡":"Confirmer la liaison de la carte",
	"请输入银行卡号":"Veuillez saisir le numéro de votre carte bancaire",
	"请选择银行":"Veuillez sélectionner une banque",
	"数据为空":"Les données sont vides",
	"下注金额":"Montant du pari",
	"下单时间":"Heure de commande",
	"结算时间":"délai de règlement",
	"充值":"recharger",
	"提现": "Retirer de l'argent",
	"我的钱包":"mon portefeuille",
	"余额(元)":"Équilibre（€）",
	"个人中心":"Centre personnel",
	"登录密码": "Mot de passe de connexion",
	"任务记录":"Enregistrement de tâches",
	"系统公告": "Annonce du système",
	"在线客服":"Service client en ligne",
	"退出登录": "Se déconnecter",
	"请完成任务单后进入":"Veuillez compléter la liste des tâches avant d'entrer",
	"请联系客服充值":"Veuillez contacter le service client pour recharger",
	"请设置收款卡":"Veuillez configurer une carte de paiement",
	"功能已禁用":"Fonctionnalité désactivée",
	"账号下线":"Compte hors ligne",
	"登录/注册": "Connexion/Inscription",
	"登录可享受更多服务":"Connectez-vous pour profiter de plus de services",
	"基本信息":"Informations de base",
	"头像":"avatar",
	"选择头像": "Sélectionnez un avatar",
	"确定": "Bien sûr",
	"取消": "Annuler",
	"真实姓名":"vrai nom",
	"未设置":"pas réglé",
	"性别": "genre",
	"男":"mâle",
	"女": "femelle",
	"未知": "inconnu",
	"绑定信息":"informations contraignantes",
	"已绑定":"Lié",
	"无":"aucun",
	// "系统公告": "Annonce du système",
	"收款卡信息": "Informations sur la carte de paiement",
	"添加收款卡":"Ajouter une carte de paiement",
	"提示:请绑定大型商业银行,如需修改,请您联系在线客服":"Astuce : Veuillez vous associer à une grande banque commerciale. Si vous devez le modifier, veuillez contacter le service client en ligne.",
	"请设置姓名后再绑定银行卡":"Veuillez indiquer votre nom avant de lier la carte bancaire.",
	"修改登录密码":"Changer le mot de passe de connexion",
	"旧密码":"Ancien mot de passe",
	"请输入您的旧密码":"Veuillez entrer votre ancien mot de passe",
	"新密码": "Nouveau mot de passe",
	"请输入您的新密码":"Veuillez entrer votre nouveau mot de passe",
	"请再次输入您的新密码":"Veuillez saisir à nouveau votre nouveau mot de passe",
	"保存":"sauvegarder",
	"修改真实姓名":"Changer son vrai nom",
	"姓名":"Nom",
	"请输入真实姓名":"Veuillez entrer votre vrai nom",
	"为了您账户安全,真实姓名需要与绑定银行卡姓名一致":"Pour la sécurité de votre compte, votre vrai nom doit être cohérent avec celui figurant sur la carte bancaire liée.",
	"请勿重复设置":"Ne répétez pas les réglages.",
	"性别修改":"modification du genre",
	"提现中心":"Centre de retrait",
	"提现记录":"Dossiers de retrait",
	"提现金额(元)": "Montant du retrait (€)",
	// "全部": "tous",
	"1.单笔限额：最低": "1. 1. Limite de transaction unique : minimum",
	"元，最高":"le €, le plus élevé",
	"2.提现次数：一天最高提现": "2. Nombre de retraits : Retrait maximum en une journée",
	"次":"fréquence",
	"3.到账时间：一般到账时间在5分钟左右，最快2分钟内到账":"3. Délai de paiement : Généralement, le délai de paiement est d’environ 5 minutes et le temps le plus rapide est de 2 minutes.",
	"限额说明":"Description de la limite",
	"余额":"équilibre",
	"马上提现": "Retirer de l'argent immédiatement",
	"请填写正确的金额":"Veuillez remplir le montant correct",
	// "提现记录":"Dossiers de retrait",
	// "数据为空":"Les données sont vides",
	"说明": "illustrer",
	"金额":"Montant",
	"提交时间":"Heure de soumission",
	"审核时间": "temps de révision",
	"没有更多了": "pas plus",
	"播放":"jouer",
	"次播放":"joue",
	// "热门推荐":"Recommandations populaires",
	// "账号下线":"Compte hors ligne",
	"请充值后观看视频": "Veuillez recharger pour regarder la vidéo",
	"填写收款卡": "Remplissez la carte de paiement",
	// "任务记录":"Enregistrement de tâches",
	"选妃详情":"Détails de la sélection des concubines",
	// "我的":"le mien",
	"视频":"vidéo",
	"游戏":"jeu",
	// "在线客服":"Service client en ligne",
	"设置":"installation",
	// "修改真实姓名":"Changer son vrai nom",
	"修改性别":"Modifier le sexe",
	"登录密码管理":"Gestion des mots de passe de connexion",
	"详情页面":"Page de détails",
	"视频播放":"lecture vidéo",
	"请填写完整": " Merci de remplir le complet",
	"两次密码输入不一致": "Les deux entrées de mot de passe sont incohérentes",
	"写真": "photo",
	"现在预约": "Prenez rendez-vous maintenant",
	"余额不足":"Solde insuffisant",
	"扣款失败":"Échec de la déduction",
	"下注异常":"Exception aux paris",
	"投注成功":"pari réussi",
	"参数异常":"Exception de paramètre",
	"数据不存在":"Les données n'existent pas",
	"数据获取失败":"L'acquisition des données a échoué",
	"数据获取成功":"Acquisition de données réussie",
	"鉴权错误":"Erreur d'authentification",
	"更换头像成功":"Changer d'avatar avec succès",
	"更新头像失败":"Échec de la mise à jour de l'avatar",
	"请输入真实姓名后再填写银行卡":"Merci de saisir votre vrai nom avant de renseigner votre carte bancaire",
	"请输入提现密码后再填写银行卡":"Merci de saisir le mot de passe de retrait puis de renseigner la carte bancaire",
	"已设置过银行卡":"Déjà configuré une carte bancaire",
	"设置银行卡成功":"Configurer avec succès la carte bancaire",
	"设置银行卡失败":"Échec de la configuration de la carte bancaire",
	"设置提现密码成功":"Définir le mot de passe de retrait avec succès",
	"设置提现密码失败":"Échec de la définition du mot de passe de retrait",
	"修改密码成功":"Mot de passe modifié avec succès",
	"修改密码失败":"Échec de la modification du mot de passe",
	"设置姓名成功":"Nom défini avec succès",
	"设置姓名失败":"Échec de la définition du nom",
	"设置性别成功":"Définir le sexe avec succès",
	"设置性别失败":"Échec de la définition du sexe",
	"打码量不足":"Volume de codage insuffisant",
	"提现金额不能少于":"Le montant du retrait ne peut être inférieur à",
	"提现金额不能大于":"Le montant du retrait ne peut être supérieur à",
	"当日提现次数已用完":"Le nombre de retraits pour la journée est épuisé",
	"余额不足":"Solde insuffisant",
	"提现失败":"Échec du retrait",
	"提现成功":"Retirer avec succès",
	"扣款失败":"Échec de la déduction",
	"结算中":"Règlement",
	"已结算":"Réglé",
	"盈利":"profit",
	"亏损":"Perte",
	"待结算":"En attente de règlement",
	"获取信息成功":"Informations obtenues avec succès",
	"待审核":"En attente d'examen",
	"审核成功":"Examen réussi",
	"审核退回":"Examen réussi",
	"网络异常，请重新登录":"Anomalie du réseau, veuillez vous reconnecter",
	"用户不存在":"L'utilisateur n'existe pas",
	"密码错误":"Mauvais mot de passe",
	"账号被禁用":"Le compte est désactivé",
	"登录成功":"Connexion réussie",
	"用户名不能存在中文":"Le nom d'utilisateur ne peut pas exister en chinois",
	"用户名位数错误":"Mauvais nombre de chiffres dans le nom d'utilisateur",
	"密码位数错误":"Chiffres du mot de passe erronés",
	"邀请码不能为空":"Le code d'invitation ne peut pas être vide",
	"邀请码不存在":"Le code d'invitation n'existe pas",
	"注册成功":"Inscription réussie",
	"注册失败":"L'inscription a échoué",
	"用户已存在":"L'utilisateur existe déjà",
}
